import React from "react";
import { Input } from "reactstrap";

class DimsCheckBox extends React.Component {
  render() {
    return (
      <Input type="checkbox"  {...this.props}>
        {this.props.children}
      </Input>
    );
  }
}
export default DimsCheckBox;
